import classNames from 'classnames';
import type { ComponentType, JSX, PropsWithChildren } from 'react';
import React from 'react';
import { components } from 'react-select-modern';

import type { ISelectSingleValueProps } from './SelectOptions.types';

type TSingleValueShim<T> = Omit<
  ISelectSingleValueProps<T>,
  'children' | 'className' | 'getClassNames'
> & {
  getClassNames: (name: never, props: never) => string;
};

const SingleValue = components.SingleValue as unknown as ComponentType<
  PropsWithChildren<TSingleValueShim<unknown>>
>;

/** The `SingleValue` counterpart to {@link SelectOption}; that file explains the why. */
function SelectSingleValue<T>({
  children,
  className,
  getClassNames,
  ...props
}: Readonly<ISelectSingleValueProps<T>>): JSX.Element {
  const singleValueProps: TSingleValueShim<T> = {
    ...props,
    getClassNames: (name, styleProps): string =>
      classNames(getClassNames?.(name, styleProps), className),
  };

  return <SingleValue {...singleValueProps}>{children}</SingleValue>;
}

export default SelectSingleValue;
